export default "__VITE_ASSET__7854f924__"